/** Shared homepage-style product carousels (Featured, Trending, etc.). */

export const HOME_CAROUSEL_SECTION_LIMIT = 8;

export const homeCarouselAutoPausedRef = { current: false };

export function getHomeCarouselGroupSize() {
  if (typeof window === 'undefined') return 4;
  return window.innerWidth <= 768 ? 1 : 4;
}

export function homeCarouselGridKey(groupSize, slideIndex) {
  return groupSize === 1 ? 'home-carousel-one-up' : slideIndex;
}

export function getHomeCarouselSlice(
  list,
  groupSize,
  currentGroup,
  maxProducts = HOME_CAROUSEL_SECTION_LIMIT
) {
  if (!Array.isArray(list) || !list.length) return [];
  const limitedProducts = list
    .filter((p) => p && (p.id || p._id) && p.name)
    .slice(0, maxProducts);
  if (!limitedProducts.length) return [];
  const totalGroups = Math.ceil(limitedProducts.length / groupSize) || 1;
  const normalizedGroup = ((currentGroup % totalGroups) + totalGroups) % totalGroups;
  const startIndex = normalizedGroup * groupSize;
  return limitedProducts
    .slice(startIndex, startIndex + groupSize)
    .filter((p) => p && (p.id || p._id));
}

export function showHomeCarouselMobileArrows(groupSize, totalGroups) {
  return groupSize === 1 && totalGroups > 1;
}

/** Passive swipe on touchend — same as Home.js (vertical scroll friendly on iOS). */
export function bindHomeCarouselSwipe(el, swipeRef, { onLeft, onRight }) {
  if (!el) return () => {};
  const minSwipeDistance = 48;
  const opts = { passive: true };
  const onStart = (e) => {
    const t = e.targetTouches[0];
    swipeRef.current = { x: t.clientX, y: t.clientY };
  };
  const onEnd = (e) => {
    const start = swipeRef.current;
    swipeRef.current = null;
    if (!start || !e.changedTouches?.length) return;
    const end = e.changedTouches[0];
    const horizontalDistance = start.x - end.clientX;
    const verticalDistance = start.y - end.y;
    const absH = Math.abs(horizontalDistance);
    const absV = Math.abs(verticalDistance);
    if (absH < minSwipeDistance || absH <= absV * 1.35) return;
    homeCarouselAutoPausedRef.current = true;
    window.setTimeout(() => {
      homeCarouselAutoPausedRef.current = false;
    }, 700);
    if (horizontalDistance > 0) onLeft();
    else onRight();
  };
  const onCancel = () => {
    swipeRef.current = null;
  };
  el.addEventListener('touchstart', onStart, opts);
  el.addEventListener('touchend', onEnd, opts);
  el.addEventListener('touchcancel', onCancel, opts);
  return () => {
    el.removeEventListener('touchstart', onStart, opts);
    el.removeEventListener('touchend', onEnd, opts);
    el.removeEventListener('touchcancel', onCancel, opts);
  };
}
